import { AuthActions } from '~/actions/auth/action'
import { LeadActions } from '~/actions/lead/action'
import CookieService from '~/services/cookies'
import { TranslationService } from '~/services/Translation'
import { TripLeadActions } from '~/actions/trip/lead'
import { ProfileActions } from '~/actions/profile/action'

export default defineNuxtRouteMiddleware(async (to) => {
	if (import.meta.server) return

	const nuxtApp = useNuxtApp()
	const translation = TranslationService.getInstance(nuxtApp.$i18n)
	const leadId = to.query.lead_id as string
	const salesLeadId = to.query.sales_lead_id as string
	if (leadId) return handleB2BLead(leadId, translation)
	if (salesLeadId) return handleSalesLead(salesLeadId, translation)
})

async function handleB2BLead(leadId: string, translation: TranslationService) {
	AuthActions.saveLeadId(leadId)
	const isLoggedIn = await isAuthenticated()
	if (!isLoggedIn) return
	try {
		const itinerary = await LeadActions.createTrip(leadId)
		if (itinerary?.id)
			return navigateTo(`/${translation.getLocale()}/trip/${itinerary.id}/dashboard`)
		else return navigateTo(`/${translation.getLocale()}/home/`)
	} catch {
		return navigateTo(`/${translation.getLocale()}/home/`)
	}
}

async function handleSalesLead(salesLeadId: string, translation: TranslationService) {
	CookieService.setSalesLeadId(salesLeadId)
	const isLoggedIn = await isAuthenticated()
	if (!isLoggedIn) return
	try {
		const itinerary = await TripLeadActions.createTrip(salesLeadId)
		if (itinerary?.id)
			return navigateTo(`/${translation.getLocale()}/trip/${itinerary.id}/dashboard`)
		else return navigateTo(`/${translation.getLocale()}/home/`)
	} catch {
		return navigateTo(`/${translation.getLocale()}/home/`)
	}
}

async function isAuthenticated(): Promise<boolean> {
	const authCookie = CookieService.getAuthCookie()
	if (!authCookie) return false
	const profile = await ProfileActions.getProfile()
	if (!profile?.id) return false
	return true
}
